const GetCitationContent = blocks => {
  const citationBlock = blocks.find(
    block =>
      block.name === "core/shortcode" &&
      block.originalContent.includes("zotpress") &&
      !block.originalContent.includes("multiple")
  )

  if (citationBlock) {
    return citationBlock.originalContent
  } else {
    const reusableBlock = blocks.find(block => block.name === "core/block")
    if (
      reusableBlock?.innerBlocks?.length &&
      reusableBlock.innerBlocks[0].name === "core/shortcode" &&
      reusableBlock.innerBlocks[0].originalContent.includes("zotpress") &&
      !reusableBlock.innerBlocks[0].originalContent.includes("multiple")
    ) {
      return reusableBlock.innerBlocks[0].originalContent
    } else {
      return null
    }
  }
}

export default GetCitationContent
